import { Controller, useForm } from 'react-hook-form';
import { RadioGroup } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import React, { useEffect, useState } from 'react';
import {
  Container,
  CustomFormLabel,
  SubContainer,
} from '@/components/MenuDrawer/MyMenuDrawer/SubMenu/Settings/SalesSettings/styles';
import { RadioV2 } from '@/components/@IntranetLibrary/Radio/RadioV2';
import { useAtom } from 'jotai';
import { appSettingState } from '@/recoil/atom';
import { AppConfig } from '@/types/api';
import { RnMessage, sendToRN } from '@/utils/function';
import { useTranslation } from 'react-i18next';

const SalesSettings = () => {
  const { t } = useTranslation();
  const [state] = useAtom(appSettingState);
  const [changeState, setChangeState] = useState<
    Pick<AppConfig, 'dayFind' | 'seasonFind'>
  >({
    dayFind: state.dayFind,
    seasonFind: state.seasonFind,
  });

  const [isChanged, setIsChanged] = useState(false);

  const { control } = useForm<{
    dayFind: 'true' | 'false';
    seasonFind: 'true' | 'false';
  }>({
    values: {
      dayFind: changeState.dayFind ? 'true' : 'false',
      seasonFind: changeState.seasonFind ? 'true' : 'false',
    },
  });

  useEffect(() => {
    if (
      state.dayFind !== changeState.dayFind ||
      state.seasonFind !== changeState.seasonFind
    ) {
      setIsChanged(true);
    } else {
      setIsChanged(false);
    }
  }, [changeState]);

  const handleClick = () => {
    if (confirm('변경된 설정을 적용하기 위해 앱을 재기동합니다.')) {
      sendToRN(RnMessage.SET_SALES_DEFAULT_DATA, {
        dayFind: changeState.dayFind,
        seasonFind: changeState.seasonFind,
      });
    }
  };

  return (
    <Container>
      <SubContainer>
        <CustomFormLabel>{t('기본 조회 일자')}</CustomFormLabel>
        <Controller
          name={'dayFind'}
          control={control}
          render={({ field: { value } }) => (
            <RadioGroup
              onChange={(e) => {
                setChangeState({
                  ...changeState,
                  dayFind: e.target.value === 'true',
                });
              }}
              value={value}
              sx={{
                '.default': {
                  '&::after': {
                    content: `"${t('사용중')}"`,
                    display: 'inline-block',
                    padding: '4px 12px',
                    borderRadius: '999px',
                    backgroundColor: 'rgba(0, 102, 204, 0.12)',
                    fontSize: '12px',
                    color: 'var(--dk-accent, #0066CC)',
                    marginLeft: 'auto',
                  },
                },
              }}
            >
              <FormControlLabel
                className={!state.dayFind ? 'default' : ''}
                value={false}
                control={<RadioV2 />}
                label={t('어제')}
              />
              <FormControlLabel
                className={state.dayFind ? 'default' : ''}
                value={true}
                control={<RadioV2 />}
                label={t('오늘')}
              />
            </RadioGroup>
          )}
        />
      </SubContainer>
      <SubContainer>
        <CustomFormLabel>{t('기본 조회 시즌')}</CustomFormLabel>
        <Controller
          name={'seasonFind'}
          control={control}
          render={({ field: { value } }) => (
            <RadioGroup
              onChange={(e) => {
                setChangeState({
                  ...changeState,
                  seasonFind: e.target.value === 'true',
                });
              }}
              value={value}
              sx={{
                '.default': {
                  '&::after': {
                    content: `"${t('사용중')}"`,
                    display: 'inline-block',
                    padding: '4px 12px',
                    borderRadius: '999px',
                    backgroundColor: 'rgba(0, 102, 204, 0.12)',
                    fontSize: '12px',
                    color: 'var(--dk-accent, #0066CC)',
                    marginLeft: 'auto',
                  },
                },
              }}
            >
              <FormControlLabel
                className={state.seasonFind ? 'default' : ''}
                value={true}
                control={<RadioV2 />}
                label={t('현재 시즌')}
              />
              <FormControlLabel
                value={false}
                className={!state.seasonFind ? 'default' : ''}
                control={<RadioV2 />}
                label={t('전체 시즌')}
              />
            </RadioGroup>
          )}
        />
      </SubContainer>
      <button
        style={{
          borderRadius: '6px',
          padding: '14px',
          color: 'white',
          backgroundColor: 'black',
          width: '100%',
          opacity: isChanged ? '1' : '0.2',
          fontSize: '14px',
        }}
        disabled={!isChanged}
        onClick={handleClick}
      >
        {t('저장')}
      </button>
    </Container>
  );
};

export default SalesSettings;
